import {
  ProjectHeaderButton,
  TeamsImage,
} from "@/containers/Project/components/ProjectHeader/styled";
import teams from "@/images/teams_logo.png";
import { projectApi, useGetProjectQuery } from "@/services";
import { Row } from "antd";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const TeamsButton = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const { data: project } = useGetProjectQuery(projectId, {
    skip: !projectId,
  });

  const onTeamsButtonClick = (): void => {
    if (!project?.microsoftTeamsURL) {
      toast.info(intl.formatMessage({ id: "project.teamCreationInProcess" }));
      return;
    }

    // @ts-ignore
    dispatch(projectApi.endpoints.checkTeamsAccess.initiate(project.id))
      .then((data: unknown) => {
        if (data) {
          const newTab = window.open();

          if (newTab) {
            newTab.location.href = project.microsoftTeamsURL;
          }
        } else {
          toast.info(intl.formatMessage({ id: "project.tooManyTeams" }));
        }
      })
      .catch(() => {
        toast.error(intl.formatMessage({ id: "project.addUserToTeamError" }));
      });
  };

  return (
    <ProjectHeaderButton
      type="text"
      data-test-id="microsoft-teams-button"
      onClick={onTeamsButtonClick}
    >
      <Row justify="center">
        <TeamsImage
          src={teams}
          style={{ height: "20px", width: "20px" }}
          alt="teams"
        />
      </Row>
      <Row justify="center">
        {intl.formatMessage({ id: "project.microsoftTeamsButtonLabel" })}
      </Row>
    </ProjectHeaderButton>
  );
};
